import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  button: {
    padding: theme.spacing(1),
    minWidth: 10,
  },
  count: {
    color: theme.palette.grey2,
    fontSize: 14,
    marginLeft: theme.spacing(0.5),
    [theme.breakpoints.down('md')]: {
      fontSize: 12,
      marginLeft: 2,
    },
    [theme.breakpoints.downLandscape('md')]: {
      ...(theme.isMobileDevice && {
        fontSize: 12,
        marginLeft: 2,
      }),
    },
  },
  commonMark: {
    fontSize: 14,
    marginLeft: 6,
    [theme.breakpoints.down('md')]: {
      fontSize: 12,
      marginLeft: 3,
    },
    [theme.breakpoints.down('sm')]: {
      marginLeft: 0,
    },
    [theme.breakpoints.downLandscape('md')]: {
      ...(theme.isMobileDevice && {
        fontSize: 12,
        marginLeft: 3,
      }),
    },
  },
  userIcon: {
    [theme.breakpoints.down('md')]: {
      height: 12,
      width: 12,
    },
    [theme.breakpoints.downLandscape('md')]: {
      ...(theme.isMobileDevice && {
        height: 12,
        width: 12,
      }),
    },
  },
}));
